// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const Lab_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M20.783 18.728 15 9.086V3.75h.75a.75.75 0 0 0 0-1.5h-7.5a.75.75 0 0 0 0 1.5H9v5.336l-5.783 9.642A1.5 1.5 0 0 0 4.5 21h15a1.5 1.5 0 0 0 1.286-2.272ZM10.393 9.68a.74.74 0 0 0 .107-.386V3.75h3v5.544a.74.74 0 0 0 .107.386l3.583 5.976c-1.125.222-2.725.129-4.852-.948-1.491-.754-2.91-1.155-4.239-1.2ZM4.5 19.5l2.676-4.46c1.336-.164 2.841.173 4.483 1.004 1.781.901 3.281 1.208 4.5 1.208a6.6 6.6 0 0 0 1.833-.253L19.5 19.5Z',
  viewBox: '0 0 24 24',
  glyph: 'Lab_Stroke2_Corner0_Rounded',
})
